import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { TableBaseConocimiento } from './components/TableBaseConocimiento';
import { BannerInfoBaseConocimiento } from './components/BannerInfoBaseConocimiento';
import { PageLayout } from '../../../components/generics/PageLayout';
import { hasPemissions } from '../../../commons/utils';

export const BaseConocimiento = () => {
  const navigate = useNavigate();
  const [canCreate, setCanCreate] = useState(false);

  useEffect(() => {
    canCheckCanCreate();
  }, []);

  const canCheckCanCreate = async () => {
    const havePermissions = await hasPemissions(
      'modulo.inteligencia.artificial',
      'modulo.inteligencia.artificial.base.conocimiento',
      'create'
    );
    setCanCreate(havePermissions);
  };

  const handleOpenCreate = () => navigate('/inteligencia-artificial/base-conocimiento/crear');

  return (
    <PageLayout
      title="Gestión de Bases de Conocimiento"
      mainModule="Inteligencia Artificial"
      icon="Dataset"
      infoAlert="Administra las fuentes de información utilizadas por los Agentes de IA"
      actionButtons={
        canCreate && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenCreate}
          >
            Nueva Base
          </Button>
        )
      }
    >
      <Box sx={{ pt: 3 }}>
        <TableBaseConocimiento />
        <BannerInfoBaseConocimiento />
      </Box>
    </PageLayout>
  );
};
